import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';
import {FormattedMessage, injectIntl} from 'react-intl';

import styles from './RadioButton.less';

const RadioButtonItem = ({
  checked,
  disabled,
  intl,
  label,
  name,
  onChange,
  value,
}) => (
  <span className={styles.dlRadioButtonItem}>
    <Form.Check
      type={'radio'}
      className={styles.dlRadioButtonItemInput}
      id={`${name}-${value}`}
    >
      <Form.Check.Input
        type={'radio'}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        title={utils.TranslateUtils.translate({id: label}, intl)}
      />
      <Form.Check.Label>
        <span>
          <FormattedMessage id={label} />
        </span>
      </Form.Check.Label>
    </Form.Check>
  </span>
);

RadioButtonItem.displayName = 'RadioButtonItem';

/* eslint-disable react/no-unused-prop-types */
RadioButtonItem.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

RadioButtonItem.defaultProps = {
  checked: false,
  disabled: false,
  label: '',
  name: '',
};

export default injectIntl(RadioButtonItem);
